<!-- WHY: WCAG 2.4.1 bypass-blocks. Plain fragment anchor on purpose — the Router only
     reacts to popstate (router.mjs filters `event['type'] === 'popstate'`), so a hashchange
     cannot start a navigation and this can never re-fire NavigationEnd on the checkout flow. -->
<a class="skip-to-main" href="#main-content">Skip to main content</a>
<mat-sidenav-container class="app-sidenav-container">
  <mat-sidenav #sidenav mode="over" position="start" class="app-sidenav">
    <app-sidebar (closeSidebar)="sidenav.close()"></app-sidebar>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="app-main">
        <app-header (toggleSidebar)="sidenav.toggle()"></app-header>
        <main id="main-content" class="app_main_body" tabindex="-1">
            <router-outlet />
        </main>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<app-cookie-consent></app-cookie-consent>
